import { useLayoutEffect, useRef, useState } from 'react';

/** 이 너비보다 작아지면 가로 메뉴 숨김 + 햄버거 메뉴 (모바일/좁은 화면 전용) */
export const LANDING_HEADER_NAV_COLLAPSE_BP_PX = 1160;

const COLLAPSE_MEDIA_QUERY = `(max-width: ${LANDING_HEADER_NAV_COLLAPSE_BP_PX - 1}px)`;

/**
 * 헤더 가로 메뉴 접힘 — 좁은 뷰포트에서만 햄버거.
 * 언어별 조기 접힘/실측 오버플로 접힘은 사용하지 않음 (간격 축소로 대응).
 */
export function useLandingHeaderNavCollapse(enabled: boolean, _remeasureKey = '') {
  const headerRef = useRef<HTMLElement | null>(null);
  const logoRef = useRef<HTMLDivElement | null>(null);
  const midRef = useRef<HTMLUListElement | null>(null);
  const actionsRef = useRef<HTMLDivElement | null>(null);
  const [isNavCollapsed, setIsNavCollapsed] = useState(false);

  useLayoutEffect(() => {
    if (!enabled) {
      setIsNavCollapsed(false);
      return undefined;
    }

    const mediaQuery = window.matchMedia(COLLAPSE_MEDIA_QUERY);

    const update = () => {
      setIsNavCollapsed(mediaQuery.matches);
    };

    update();
    mediaQuery.addEventListener('change', update);

    return () => {
      mediaQuery.removeEventListener('change', update);
    };
  }, [enabled]);

  return {
    headerRef,
    logoRef,
    midRef,
    actionsRef,
    isNavCollapsed,
  };
}
